module.exports = __webpack_public_path__ + "img/lianxi.9521fb1f.png";